import { Network } from "@/network";
import { TCBReceiptApi } from "@/network/pb/proto";
import { Log } from "@/util";

class AnnouncementModel {
  private static sInstance: AnnouncementModel;

  public static get instance(): AnnouncementModel {
    if (!AnnouncementModel.sInstance) {
      AnnouncementModel.sInstance = new AnnouncementModel();
    }

    return AnnouncementModel.sInstance;
  }

  private announcementList = TCBReceiptApi.Protobuf.AnnouncementList.create();
  private specificAnnouncement = TCBReceiptApi.Protobuf.Announcement.create();

  public async getAnnouncement(announcementQuery: Uint8Array): Promise<void> {
    await Network.sendAPI("/api/announcement/get", "post", announcementQuery)
      .then(rawResponse => {
        const response = TCBReceiptApi.Protobuf.Response.decode(
          new Uint8Array(rawResponse.data as ArrayBufferLike)
        );
        this.announcementList = TCBReceiptApi.Protobuf.AnnouncementList.decode(
          new Uint8Array(response.item)
        );
      })
      .catch(error => {
        Log.error(error);
      });
  }

  public async getAnnouncementByCondition(
    announcementQuery: Uint8Array
  ): Promise<void> {
    await Network.sendAPI(
      "/api/front/announcement/get_by_condition",
      "post",
      announcementQuery
    )
      .then(rawResponse => {
        const response = TCBReceiptApi.Protobuf.Response.decode(
          new Uint8Array(rawResponse.data as ArrayBufferLike)
        );
        this.announcementList = TCBReceiptApi.Protobuf.AnnouncementList.decode(
          new Uint8Array(response.item)
        );
      })
      .catch(error => {
        Log.error(error);
      });
  }

  public async getAnnouncementByAnnouncementID(
    announcementQuery: Uint8Array
  ): Promise<void> {
    await Network.sendAPI(
      "/api/front/announcement/get_by_announcement_id",
      "post",
      announcementQuery
    )
      .then(rawResponse => {
        const response = TCBReceiptApi.Protobuf.Response.decode(
          new Uint8Array(rawResponse.data as ArrayBufferLike)
        );
        this.specificAnnouncement = TCBReceiptApi.Protobuf.Announcement.decode(
          new Uint8Array(response.item)
        );
      })
      .catch(error => {
        Log.error(error);
      });
  }

  public getAnnouncementList(): TCBReceiptApi.Protobuf.AnnouncementList {
    return this.announcementList;
  }

  public getSpecificAnnouncement(): TCBReceiptApi.Protobuf.Announcement {
    return this.specificAnnouncement;
  }

  public async downloadFile(queryString: string): Promise<void> {
    const uri = "/api/front/announcement/get_file?" + queryString;
    await Network.downloadFile(uri);
  }
}

const announcementModel = AnnouncementModel.instance;

export { announcementModel as AnnouncementModel };
